export const LOAD_TODOS = "LOAD_TODOS";
export const LOAD_TODOS_SUCCESS = "LOAD_TODOS_SUCCESS";
export const LOAD_TODOS_ERROR = "LOAD_TODOS_ERROR";
export const UPDATE_TODOS = "UPDATE_TODOS";
export const UPDATE_TODOS_SUCCESS = "UPDATE_TODOS_SUCCESS";
export const UPDATE_TODOS_ERROR = "UPDATE_TODOS_ERROR";
export const UPDATE_REMINDERS = "UPDATE_REMINDERS";
export const UPDATE_REMINDERS_SUCCESS = "UPDATE_REMINDERS_SUCCESS";
export const UPDATE_REMINDERS_ERROR = "UPDATE_REMINDERS_ERROR";



// WEBPACK FOOTER //
// ./src/store/actions/todos.js